import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Polyfills needed for Solana web3.js in the browser
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;

// Get the root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);